import { useEffect } from "react";
import Divider from "../../components/common/aesthetics/Divider.jsx";
import AppBreadcrumbs from "../../components/common/breadcrumbs/AppBreadcrumbs.jsx";
import FormReceipts from "../../components/common/form/FormReceipts.jsx";
import TableReceipts from "../../components/common/table/TableReceipts.jsx";
import Page from "../../components/layout/Page.jsx";
import useReceiptFilters from "../../hooks/useReceiptFilters.jsx";
import useReceipts from "../../hooks/useReceipts.jsx";
import { useFilterStore } from "../../stores/receiptFilterStore.js";

function Receipts() {
  const { data, error, loading, refetch } = useReceipts();
  const { filters } = useReceiptFilters();

  useEffect(() => {
    async function run() {
      const { filters } = useFilterStore.getState();
      const cleaned = Object.fromEntries(
        Object.entries(filters).filter(([, v]) => v !== "" && v != null),
      );
      if (cleaned.processed !== undefined) {
        cleaned.processed = cleaned.processed === "true";
      }
      await refetch(cleaned);
    }
    run();
  }, [refetch]);

  return (
    <Page>
      <AppBreadcrumbs currentPage="Recepciones" />
      <div>
        <div className="mb-6">
          <h1 className="font-bold text-2xl">Recepciones de Documentos de Acompañamiento</h1>
          <span>Listado de recepciones de documentos de acompañamiento recibidos de la AEAT</span>
        </div>
        <FormReceipts refetch={refetch} />
        <Divider />
        <TableReceipts data={data} error={error} loading={loading} refetch={refetch} formData={filters} />
      </div>
    </Page>
  );
}

export default Receipts;
